module.exports = __webpack_public_path__ + "img/3b04521.png";